import PromocodesPage from './PromocodesPage';

export default PromocodesPage;
